import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { propertyApi } from '../services/api';
import {
  PlusIcon,
  PencilSquareIcon,
  TrashIcon,
  UserGroupIcon
} from '@heroicons/react/24/outline';

const Properties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const fetchProperties = async () => {
    setLoading(true);
    try {
      const response = await propertyApi.getAll();
      setProperties(response.data);
    } catch (error) {
      toast.error('Failed to load properties');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchProperties();
  }, []);
  
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this property? This will also delete all associated tenants and receipts.')) {
      try {
        await propertyApi.delete(id);
        toast.success('Property deleted successfully');
        fetchProperties();
      } catch (error) {
        toast.error('Failed to delete property');
        console.error(error);
      }
    }
  };
  
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Properties</h1>
        <Link
          to="/properties/new"
          className="btn-primary inline-flex items-center"
        >
          <PlusIcon className="h-5 w-5 mr-1" />
          Add Property
        </Link>
      </div>
      
      {loading ? (
        <div className="text-center py-8">Loading properties...</div>
      ) : properties.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">No properties found</h3>
          <p className="text-gray-600 mb-4">
            Start by adding your first property to the system.
          </p>
          <Link
            to="/properties/new"
            className="btn-primary inline-flex items-center"
          >
            <PlusIcon className="h-5 w-5 mr-1" />
            Add Property
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {properties.map((property) => (
            <div key={property.id} className="bg-white rounded-lg shadow overflow-hidden">
              <div className="p-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">{property.name}</h3>
                <p className="text-gray-600 mb-1">{property.address}</p>
                <p className="text-gray-600 mb-4">{property.city}, {property.postalCode}, {property.country}</p>
                
                <div className="flex space-x-2">
                  <Link
                    to={`/properties/${property.id}/tenants`}
                    className="btn-secondary inline-flex items-center text-sm flex-1 justify-center"
                  >
                    <UserGroupIcon className="h-4 w-4 mr-1" />
                    Tenants
                  </Link>
                  <Link
                    to={`/properties/edit/${property.id}`}
                    className="text-blue-600 hover:text-blue-800 p-2"
                    title="Edit"
                  >
                    <PencilSquareIcon className="h-5 w-5" />
                  </Link>
                  <button
                    onClick={() => handleDelete(property.id)}
                    className="text-red-600 hover:text-red-800 p-2"
                    title="Delete"
                  >
                    <TrashIcon className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Properties;